import { Suspense, type ReactNode } from 'react'

function RouteLoadingFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="text-center">
        <div className="mx-auto h-6 w-6 animate-spin rounded-full border-4 border-primary-600 border-t-transparent dark:border-primary-400" />
        <p className="mt-2 text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  )
}

/**
 * Suspense wrapper for lazy-loaded route components.
 * Shows a centered spinner while the chunk loads.
 */
export function RouteSuspense({ children }: { children: ReactNode }) {
  return <Suspense fallback={<RouteLoadingFallback />}>{children}</Suspense>
}
